import { Client } from './../../../models/client';
import { NgxRolesService } from 'ngx-permissions';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { } from '@types/googlemaps';
import { SchoolService } from '../../../services/school.service';
import { AuthService } from '../../../services/auth.service';
import { School } from '../../../models/school';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { Select2OptionData } from 'ng2-select2';

declare const google: any;

@Component({
  selector: 'app-bus-map',
  templateUrl: './bus-map.component.html',
  styleUrls: ['./bus-map.component.css']
})
export class BusMapComponent implements OnInit, OnDestroy {
  filter = {
    schoolId: 0,
    busIds: []
  };
  filteredParams: HttpParams;
  schools: any[];
  // Map Option
  option: any;
  // Mew Map
  map: any;
  // GeoCoder
  geocoder: any;
  markerBounds: any;
  // Marker Data
  data: {};
  markersUpdater = null;
  isResponsible = false;

  public schoolsData: Array<Select2OptionData>;
  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  // ----- Start MultiSelect -----------
  optionsModelBus: number[];
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'éléments sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // Labels / Parents
  multiSelectBus: IMultiSelectOption[];
  // ----- End MultiSelect -----------


  constructor(
    private auth: AuthService,
    private http: HttpClient,
    private roleService: NgxRolesService,
  ) {
    this.geocoder = new google.maps.Geocoder();
    // fill schools in multiselect
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
    this.fillSchool();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    clearTimeout(this.markersUpdater);
  }

  initMap() {
    var center = { lat: 33.906203, lng: -6.9299658 };
    var schoolName = '';
    for (var i = 0; i < this.schools.length; i++) {
      if (this.filter.schoolId == this.schools[i].id) {
        center = { lat: parseFloat(this.schools[i].lat), lng: parseFloat(this.schools[i].lng) };
        schoolName = this.schools[i].name;
        break;
      }
    }
    // map
    this.option = {
      center: center,
      gestureHandling: 'cooperative'
    };
    this.map = new google.maps.Map(document.getElementById('bus-map'), this.option);
    this.markerBounds = new google.maps.LatLngBounds();
    // school marker
    const schoolInfowindow = new google.maps.InfoWindow({
      content: '<b>Ets : </b>' + schoolName
    });
    const schoolMarker = new google.maps.Marker({
      position: center,
      map: this.map,
      icon: 'assets/images/markers/school.png',
      // zIndex: 99
    });
    this.markerBounds.extend(center);
    schoolMarker.addListener('click', function () {
      schoolInfowindow.open(this.map, schoolMarker);
    });
  }

  fillSchool() {
    // add schools in multiselect
    let client = this.auth.getUser();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
    }
    const params = new HttpParams({
      fromObject: {
        clientId: client.id,
      }
    });

    this.http.get('/api/school/lookup', { params })
      .subscribe(
        (schools: any[]) => {
          if (schools.length) {
            this.schools = schools;
            this.schoolsData = this.schools.map(function (school, index) {
              return { id: school.id, text: school.name };
            });

            // this.filter.schoolId = this.schools[0].id;
            // this.initMap();
            // this.fillbus();
          }
        }
      );
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initMap();
    this.fillbus();
  }

  fillbus(onload = true) {
    this.optionsModelBus = [];
    let client = this.auth.getUser();
    let schoolId = this.filter.schoolId;
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      client = this.auth.getUser().School.Client;
      schoolId = this.auth.getUser().School.id;
    }
    const params = new HttpParams({
      fromObject: {
        clientId: client.id,
        schoolId: schoolId + ''
      }
    });
    this.http.get('/api/bus/lookup', { params })
      .subscribe(
        (bus: any[]) => {
          this.multiSelectBus = bus;
          if (this.multiSelectBus.length) {
            for (let i = 0; i < this.multiSelectBus.length; i++) {
              this.optionsModelBus.push(this.multiSelectBus[i].id);
            }
            if (onload) {
              this.onFilter();
            }
          }
        }
      );
  }

  onSchoolChange() {
    this.fillbus(false);
  }

  onFilter() {
    this.initMap();

    if (this.filter.schoolId != 0 && typeof this.optionsModelBus != 'undefined' && this.optionsModelBus.length != 0) {
      this.filteredParams = new HttpParams({
        fromObject: {
          schoolId: this.filter.schoolId + '',
          busIds: JSON.stringify(this.optionsModelBus)
        }
      });

      this.http.get('/api/bus/map', { params: this.filteredParams })
        .subscribe(
          (data: any) => {
            this.data = {};
            if (data.hasOwnProperty('buses')) {
              this.addMarkers(data.buses);
              this.map.fitBounds(this.markerBounds);
            }
            clearInterval(this.markersUpdater);
            this.markersUpdater = setInterval(() => { this.updateMarkers(); }, 10 * 1000);
          }
        );
    }
  }

  addMarkers(buses) {
    for (let i = 0; i < buses.length; i++) {
      this.addMarker(buses[i]);
    }
  }

  addMarker(bus) {

    const pos = new google.maps.LatLng(bus.lat, bus.lng);
    let icon;
    let iconInfowindow;
    let contentInfoWindow;
 
    const infoWindow = new google.maps.InfoWindow({
      content: '',
      disableAutoPan: true, // Disable auto-pan to prevent close button from appearing
    });

    let carfileName;

    // Check the bus.movement value and update the content and styles accordingly
    if (bus.alertMouvement === 1) {
      
      iconInfowindow = 'assets/images/icons/car-moving.svg';
      // Construct the content for the InfoWindow
      contentInfoWindow = `
      <div style="color: #00BF63; padding: 7px; display: flex; align-items: center; font-family: 'Roboto', sans-serif; font-size: 10px;">
      <b><p>${bus.name}</p></b>
      </div>
      `;
      //        <img src="${iconInfowindow}" alt="Car Icon" width="16" height="16" style="margin-right: 3px;">

    } else {
      iconInfowindow = 'assets/images/icons/car-parking.svg';
      // Construct the content for the InfoWindow
      contentInfoWindow = `
      <div style="color: #FF3131; padding: 7px; display: flex; align-items: center;font-family: 'Roboto', sans-serif; font-size: 10px;">
      <b><p>${bus.name}</p></b>
      </div>
      `;
     // <img src="${iconInfowindow}" alt="Car Icon" width="16" height="16" style="margin-right: 3px;">

    }

    console.log ('assets/images/markers/'+bus.iconeName+'/'+bus.iconeName+'-marker.png');
    if (bus.iconeName === "Colis" || bus.iconeName === "Ruche" || bus.iconeName === "Velo-Taxi"){
      icon = 'assets/images/markers/'+bus.iconeName+'/'+bus.iconeName+'-marker.png'
    } else if (bus.iconeName === "Bus") {
      icon = 'assets/images/markers/Bus/Bus-marker_'+bus.angle+'.PNG';
    } else if (bus.iconeName === "Ambulance") {
      icon = 'assets/images/markers/Ambulance/Ambulance-marker_'+bus.angle+'.png';
    } else if (bus.alertMouvement === 0) {
      icon = 'assets/images/markers/'+bus.iconeName+'-stop/'+bus.iconeName+'-marker_'+bus.angle+'.png';
    } else if (bus.alertMouvement === 1) {
      icon = 'assets/images/markers/'+bus.iconeName+'-move/'+bus.iconeName+'-marker_'+bus.angle+'.png';
    }
    const marker = new google.maps.Marker({
      position: pos,
      map: this.map,
      // icon: 'assets/images/markers/Bus/Bus-marker_'+bus.angle+'.PNG',
      icon: icon,
      //icon: 'assets/images/markers/bus.png'
      // icon: image
    }); 


    this.markerBounds.extend(pos);

    // Open the permanent InfoWindow by default
    infoWindow.setContent(contentInfoWindow);
    infoWindow.open(this.map, marker);


    // Inject custom CSS to hide the close button in the permanent InfoWindow
    infoWindow.addListener('domready', () => {
          $(".gm-style-iw").parent().find("button").removeAttr("style").hide();
          // Remove padding to fit the border to the edge of the info window
          $(".gm-style-iw").css({padding: "0"});
          // Remove overflow property
          $(".gm-style .gm-style-iw-d").css("overflow", "visible");
          // Set the width of the ::after pseudo-element to 9 pixels ==> not working I dont know why
          //$(".gm-style .gm-style-iw-tc").css("width", "9px");
          //$(".gm-style .gm-style-iw-tc::after").css({width: "9px"});
          // Remove the element with class .gm-style-iw-tc
          //$(".gm-style-iw-tc").remove();
    });

    // Use a timeout to apply custom CSS after the info window is displayed
    setTimeout(() => {
      $(".gm-style .gm-style-iw-tc::after").css({width: "9px"});
      console.log(" ====> Now applyed ");
    }, 4000); // Adjust the timeout duration as needed
  

    this.data[bus.id] = {
      bus: bus,
      marker: marker,
      infoWindow: infoWindow,
      isDetailedInfoVisible: false, // Track if detailed info window is visible
    };

    marker.addListener('click', () => {
      //this.openInfoWindow(bus.id);
      const markerData = this.data[bus.id];

    if (markerData.isDetailedInfoVisible) {
      // If detailed info window is visible, change the content to bus name
      markerData.infoWindow.setContent(contentInfoWindow);
    } else {
      // If detailed info window is not visible, change the content to detailed 
      this.openInfoWindow(bus.id);
    }

    // Toggle the flag
    markerData.isDetailedInfoVisible = !markerData.isDetailedInfoVisible;
    });
  }

  // Formats the bus position time for the popup.
  // bus.Time stores Morocco-local wall-clock time (DATETIME, no timezone).
  // Depending on the API/driver config the value can arrive as a plain
  // "YYYY-MM-DD HH:mm:ss" string or as an ISO string like "…T11:12:24.000Z".
  // Formatting in UTC mode prints the stored clock digits as-is, so the
  // browser's local offset (+1h) is never applied on top of the DB value.
  formatBusTime(value: any): string {
    if (!value) {
      return '-';
    }
    return moment.utc(String(value)).format('DD/MM/YYYY à HH:mm:ss');
  }

  openInfoWindow(busId) {
    if (this.data.hasOwnProperty(busId)) {
      const position = this.data[busId].bus.lat + ',' + this.data[busId].bus.lng;
      const bus = this.data[busId].bus;
      let content = `<b>Véhicule :</b> ${bus.name} <br>
      <b>Moteur :</b> ${bus.alertMouvement == 1 ? `<label style="color:#00BF63">Démarrer</label>`
      : `<label style="color: #FF3131">Arrêter</label>`}<br>
      <b>Date :</b> ${ this.formatBusTime(bus.time)}<br>
      <b>Position :</b> ${position}<br>
      <b>Vitesse :</b> ${bus.speed} km/h<br>
      <b>Kilometrage :</b> ${bus.mileage} km<br/>
      <b>Signal GSM :</b> ${bus.gsmSignalStrength}/5<br>
      <b>Batterie :</b> ${bus.extBattery > 0 ? `<label style="color:green">Connecté</label>`
      : `<label style="color:orange">Déconnecté</label>`}<br>
      <b>Etat :</b> ${bus.busStatus == 'not connected' ? `<label style="color:orange">Déconnecté</label>`
      : `<label style="color:#00BF63">Connecté</label>`}`;

      if (this.roleService.getRole('ROLE_SUPER_CLIENT')) {
        content += `<br/><b>Batterie interne :</b> ${(bus.intBattery / 1000).toFixed(2)} V`;
        content += `<br/><b>IMEI :</b> ${bus.imei || '-'}`;
        content += `<br/><b>SIM Tracker :</b> ${bus.simTracker || '-'}`;
        content += `<br/><b>Expiration SIM :</b> ${bus.simExpiration ? moment(bus.simExpiration).format('DD/MM/YYYY') : '-'}`;
      }

      content = '<div style="padding: 10px;">' + content + '</div>';
      
      this.data[busId].infoWindow.setContent(content);
      this.data[busId].infoWindow.open(this.map, this.data[busId].marker);
    }
  }

  closeInfoWindow(busId) {
    if (this.data.hasOwnProperty(busId)) {
      this.data[busId].infoWindow.close();
    }
  }

  updateMarkers() {
    this.http.get('/api/bus/map', { params: this.filteredParams })
      .subscribe(
        (data: any) => {
          // var icon = {
          //   url: "assets/images/markers/bus-01.png", // url
          //   scaledSize: new google.maps.Size(30, 71), // scaled size
          //   origin: new google.maps.Point(0,0), // origin
          //   anchor: new google.maps.Point(0, 0), // anchor
          //   rotation: 0
          // };
          let icon;
          let contentInfoWindow;
          for (let i = 0; i < data.buses.length; i++) {
            const bus = data.buses[i];
            if (this.data.hasOwnProperty(bus.id)) {
              this.data[data.buses[i].id].bus = bus;
              const pos = { lat: bus.lat, lng: bus.lng };
              this.data[data.buses[i].id].marker.setPosition(pos);
              
              console.log ('assets/images/markers/'+bus.iconeName+'/'+bus.iconeName+'-marker.png');
              if (bus.iconeName === "Colis" || bus.iconeName === "Ruche" || bus.iconeName === "Velo-Taxi"){
                icon = 'assets/images/markers/'+bus.iconeName+'/'+bus.iconeName+'-marker.png'
              } else if (bus.iconeName === "Bus") {
                icon = 'assets/images/markers/Bus/Bus-marker_'+bus.angle+'.PNG';
              } else if (bus.iconeName === "Ambulance") {
                icon = 'assets/images/markers/Ambulance/Ambulance-marker_'+bus.angle+'.png';
              } else if (bus.alertMouvement === 0) {
                icon = 'assets/images/markers/'+bus.iconeName+'-stop/'+bus.iconeName+'-marker_'+bus.angle+'.png';
              } else if (bus.alertMouvement === 1) {
                icon = 'assets/images/markers/'+bus.iconeName+'-move/'+bus.iconeName+'-marker_'+bus.angle+'.png';
              }

              // Check the bus.movement value and update the content and styles accordingly
              if (bus.alertMouvement === 1) {
                // Construct the content for the InfoWindow
                contentInfoWindow = `
                <div style="color: #00BF63; padding: 7px; display: flex; align-items: center; font-family: 'Roboto', sans-serif; font-size: 10px;">
                <b><p>${bus.name}</p></b>
                </div>
                `;
              } else {
                // Construct the content for the InfoWindow
                contentInfoWindow = `
                  <div style="color: #FF3131; padding: 7px; display: flex; align-items: center; font-family: 'Roboto', sans-serif; font-size: 10px;">
                  <b><p>${bus.name}</p></b>
                  </div>
                `;
              }

              this.data[bus.id].infoWindow.setContent(contentInfoWindow);


              //const icon ='assets/images/markers/Bus/Bus-marker_'+bus.angle+'.PNG';
              // const icon ='assets/images/markers/bus.png';
              //icon.rotation = bus.angle;
  
              this.data[data.buses[i].id].marker.setIcon(icon);
              const map = this.data[bus.id].infoWindow.getMap();
              if (map !== null && typeof map !== "undefined" && this.data[bus.id].isDetailedInfoVisible === true) {
                this.data[bus.id].infoWindow.close();
                this.openInfoWindow(bus.id);
              }
            }
          }
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/bus/bus-map/bus-map.component.ts